import { Report, ReportingEndpoint } from "../services/reporting";
import { getDelay } from "../components/delayedReport/delayedReport";
const JQUERY_SERP_POST_LOAD_LS_KEY = "isp_serp_product_latest";
const JQUERY_LANDING_PAGE_POST_LOAD_LS_KEY = "ISP_LATEST_LANDING_SLUG";
const FormattedKeys = {
    position: "pos",
    search_term: "original_search_query",
    image_id: "image_id",
    smart_navigation_category_id: "original_category_id",
    smart_navigation_category: "original_smart_navigation",
    from_product: "from_product",
    related_sources: "related_sources",
    sort_by: "sort_by",
    rec: "rec",
    narrow_by: "narrow_by",
    splited: "splited",
    product_id: "id",
    filter_names: "filter_names",
    filters_category_id_to_name: "filters_category_id_to_name",
    force_and: "force_and",
    timestamp: "timestamp",
};
const IgnoreKeys = new Set(["timestamp", "force_and", "narrow_by", "splited", "filters_category_id_to_name", "filter_names"]);
function isValidParam(param) {
    return typeof param !== "undefined" && param !== null && param !== "";
}
function getLandingPageSlug() {
    if (JQUERY_LANDING_PAGE_POST_LOAD_LS_KEY in localStorage) {
        const slug = localStorage.getItem(JQUERY_LANDING_PAGE_POST_LOAD_LS_KEY);
        localStorage.removeItem(JQUERY_LANDING_PAGE_POST_LOAD_LS_KEY);
        return slug;
    }
    return "";
}
export const hasJqueryPageReport = () => JQUERY_SERP_POST_LOAD_LS_KEY in localStorage;
export default function jqueryPageReport(platform, base) {
    if (hasJqueryPageReport()) {
        const data = JSON.parse(localStorage.getItem(JQUERY_SERP_POST_LOAD_LS_KEY));
        const url = new URL(window.location.href);
        const params = {};
        const narrowByFilter = isValidParam(data.narrow_by) && serializeNarrowByFilter(data.narrow_by);
        if (narrowByFilter) {
            params['narrow_by_filters'] = JSON.stringify(narrowByFilter);
            params['narrow_by'] = serializeNarrowBy(narrowByFilter);
        }
        if (isValidParam(data.splited) && data.splited === 1 || data.splited === 0) {
            params['real'] = 1;
        }
        Object.entries(data !== null && data !== void 0 ? data : {}).forEach(([key, value]) => {
            if (!IgnoreKeys.has(key) && isValidParam(value)) {
                let paramKey = FormattedKeys[key] || key;
                params[paramKey] = formatParam(value);
            }
        });
        if (isValidParam(data.narrow_by)) {
            params['narrow_by_filters'] = JSON.stringify(serializeNarrowByFilter(data.narrow_by));
        }
        if (url.searchParams.has('variant')) {
            params['variant_id'] = url.searchParams.get('variant');
        }
        const slug = getLandingPageSlug();
        if (slug) {
            params['lp_slug'] = slug;
        }
        localStorage.removeItem(JQUERY_SERP_POST_LOAD_LS_KEY);
        function report() {
            Report(Object.assign(Object.assign({}, base), { endpoint: ReportingEndpoint.General, upType: slug ? 19 : undefined, params })).then(() => {
                console.log(`report complete, took ${parseInt(String((Date.now() - window.performance.timeOrigin) / 1000))}s with a ${delay}s delay`);
            });
        }
        const delay = getDelay(5000);
        if (delay) {
            setTimeout(report, delay);
        }
        else {
            report();
        }
    }
}
const serializeNarrowByFilter = (narrow) => {
    if (!narrow) {
        return undefined;
    }
    const narrowKeys = {};
    for (const term of narrow) {
        const [id, value] = term;
        if (id in narrowKeys) {
            narrowKeys[id].push(value);
        }
        else {
            narrowKeys[id] = [value];
        }
    }
    return Object.entries(narrowKeys);
};
const serializeNarrowBy = (narrow) => {
    return String(narrow);
};
function formatParam(value) {
    if (typeof value === "string") {
        return value;
    }
    else if (typeof value === "number" && value === 0 || value === 1) {
        return value;
    }
    else if (typeof value === "number") {
        return String(value);
    }
    else {
        return JSON.stringify(value);
    }
}
//# sourceMappingURL=jqueryPageReport.js.map